import { onAutocompleteFocus, onSearch, search } from "../services/search.service";
import '../../styles/web-components/search-form.scss';
import { SEARCH_CLOSE } from "../constants/events.constants";
class SearchForm extends HTMLElement {
    constructor() {
        super();
    }
    async connectedCallback() {
        this.form = this.querySelector('form');
        this.searchInput = this.querySelector('input');
        this.resetButton = this.querySelector('.search-form__reset');
        this.closeButton = this.querySelector('.search-form__cancel');
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
        this.resetButton.addEventListener("click", () => this.handleReset());
        this.closeButton.addEventListener("click", () => this.handleClose());
        onSearch(() => {
            this.handleClose();
        });
        onAutocompleteFocus(() => {
            this.accessibilityUpdate();
        });
    }
    handleSubmit(e) {
        e.preventDefault();
        const term = this.searchInput.value;
        if (term) {
            search(term);
        }
    }
    handleReset() {
        this.searchInput.value = '';
        this.setFocus();
    }
    handleClose() {
        this.dispatchEvent(new CustomEvent(SEARCH_CLOSE, { bubbles: true }));
    }
    setFocus() {
        this.waitForFindifyAutocompleteDropdownOnce().then(() => this.accessibilityUpdate());
        this.searchInput.focus();
    }
    /**
     * fixes an accessibility issue due to aria-attribute violations
     * see: https://usablenet.atlassian.net/browse/UNTUC001AV-357
     */
    accessibilityUpdate() {
        this.searchInput.removeAttribute('aria-activedescendant'); // a11y fix: this attribute is initially empty
        this.searchInput.removeAttribute('aria-owns'); // a11y fix: this attribute refers to an id that doesn't exist in the DOM yet
        let controlledIds = "FindifyAutocompleteSuggestions";
        const findifyProductList = document.querySelector('.findify-components-autocomplete--products');
        if (findifyProductList === null || findifyProductList === void 0 ? void 0 : findifyProductList.firstElementChild) {
            controlledIds += " FindifySuggestedProducts";
        }
        this.searchInput.setAttribute('aria-controls', controlledIds); // a11y fix: add aria-controls for both findify sections
    }
    waitForFindifyAutocompleteDropdownOnce() {
        return new Promise((resolve) => {
            const observer = new MutationObserver((mutations, observerInstance) => {
                const isWrapperAdded = mutations.find(m => Array.from(m.addedNodes).find(n => n.classList.contains("findify-layouts--autocomplete--dropdown__wrapper")));
                if (isWrapperAdded) {
                    observerInstance.disconnect();
                    resolve();
                }
            });
            observer.observe(this.querySelector('.findify-autocomplete'), { childList: true, subtree: true });
        });
    }
}
if (!window.customElements.get("search-form")) {
    customElements.define("search-form", SearchForm);
}
